module.exports = __webpack_public_path__ + "img/tooltip_03-vallone-como-01B.9cf6a69b.jpg";